import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
@Injectable({
  providedIn: 'root'
})
export class OperationalDashboardService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  GetExpiringAuthList(params: URLSearchParams): Observable<any> {
    let url = "api/ClientAuthorization/getExpiringAuthorizationCount?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getclaim(params: URLSearchParams): Observable<any> {

    let url = "api/Claims/getActiveandArchiveClaimAmountandCount?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  getpowerbiToken(): Observable<any> {
    let url = "api/PowerBI/GetAccessToken?"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

}
